import { render } from "./InfiniteScroll.vue?vue&type=template&id=22372414&ts=true"
import script from "./InfiniteScroll.vue?vue&type=script&lang=ts"
export * from "./InfiniteScroll.vue?vue&type=script&lang=ts"

import "./InfiniteScroll.vue?vue&type=style&index=0&id=22372414&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__